// The screens this app has.
//
// OVERRIDDEN FROM THE SCAFFOLD, deliberately. The chassis ships bottom-tabs with a worked
// Home/Items/Detail example, which is the right default for most apps and the wrong one for
// this: a kitchen planner is a single full-bleed canvas with a sheet over it, and a tab bar
// would sit exactly where the sheet does while offering nowhere else to go.
//
// So there is one screen, no tab shell, and the router below routes straight to it. If this
// grows a second destination -- "my kitchens", most likely -- it is a stack, not tabs.

import PlannerPage from './pages/PlannerPage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'planner',
    path: '/planner',
    label: 'Planner',
    component: PlannerPage,
    primary: true,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);
export const DESTINATION_ROUTES = PRODUCT_ROUTES.filter((r) => r.destination ?? r.primary).slice(0, 5);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
